import { Flex, Image, Popconfirm, Tooltip } from 'antd';
import {
  Container,
  Description,
  StepImageContainer,
  CauseName,
  DeleteButton,
  StepSigns,
  StepSignImage,
} from './style';
import { Step } from '../../types';
import Icon from '@ant-design/icons';
import { SVGEdit, SVGUnlink } from '../../images';
import {
  getIso7010SignImagePath,
  iso7010SignDescriptions,
  parseSignNames,
} from '../../constants';

const StepCard = ({
  step,
  onDelete,
  onEdit,
  readOnly,
}: {
  step: Step;
  onDelete: () => void;
  onEdit: () => void;
  readOnly?: boolean;
}) => {
  return (
    <Container vertical gap={8}>
      <Flex gap={8}>
        <StepImageContainer>
          <Image
            src={step.images?.[0]?.url}
            preview={!!step.images?.[0]?.url}
            fallback="/placeholder.png"
          />
        </StepImageContainer>
        <Flex vertical flex={1}>
          <CauseName>{step.name}</CauseName>
          {!!step.signNames && (
            <StepSigns>
              {parseSignNames(step.signNames).map((code) => (
                <Tooltip
                  key={code}
                  title={`${code} - ${iso7010SignDescriptions[code]}`}
                >
                  <StepSignImage
                    src={getIso7010SignImagePath(code)}
                    alt={code}
                    title={code.toLowerCase()}
                  />
                </Tooltip>
              ))}
            </StepSigns>
          )}
        </Flex>
        {!readOnly && (
          <Flex align="center">
            <DeleteButton style={{ fontSize: 16 }} onClick={onEdit}>
              <Icon component={SVGEdit} />
            </DeleteButton>
            <Popconfirm
              placement="topRight"
              title={`Are you sure you want to remove "${step.name}"`}
              okText="Yes"
              cancelText="No"
              onConfirm={onDelete}
            >
              <DeleteButton>
                <Icon component={SVGUnlink} />
              </DeleteButton>
            </Popconfirm>
          </Flex>
        )}
      </Flex>
      {step.description && <Description>{step.description}</Description>}
    </Container>
  );
};

export default StepCard;
